import React from 'react';
import {Result, Button} from "antd";
import {withRouter, useHistory} from 'react-router-dom';
import ButtonMailto from '../components/feedbackButton';


function RequestAccess() {

    const history = useHistory();

    const routeChange = (path) =>{ 
        history.push(path);
    }

    return(
            <Result
                status="403"
                title="403"
                subTitle="Hi! to get access to mapping-tool, you need to request-access below. If you already have access, procceed to Login page. Please avoid submitting multiple requests, we will try to get back to you asap."
                extra={
                <div style={{display: 'flex', gap: '10px', justifyContent: 'center', lineHeight: '20px'}}>
                    <Button onClick={() => routeChange('/login')} type="primary">Login Page</Button>
                    <ButtonMailto label="Request Access" mailto="mailto:data-app-eng@1up.health?subject=Request Access to Mapping Tool&body=Please enter the following information:%0D%0AYour Full Name:%0D%0AYour 1Up Email: %0D%0A%0D%0AWe will get back to you soon, thanks!" />
                </div>}
            />
    );
}

export default withRouter(RequestAccess);
